module.exports = "https://static.wanderu.com/ui-react/_next/static/media/explorebywanderu-social.4849f744.png";